module.exports = __webpack_public_path__ + "media/images/haircut/main_image2-8bd8939baafef669547b5f4d972ad808.jpg";